/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import Grid from "../../shared/Grid";
import TopicFormWrapper from "./TopicFormWrapper";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as topicsActions from "../../../actions/topicsActions";

class TopicsPage extends Component {
	constructor(props) {
		super(props);
		this.appId = "";
		this.appKey = this.props.match.params.appKey;
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			this.appId = app ? app.id : "";
		}
	}

	getAppId = () => {
		let appId = "";
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			appId = app ? app.id : "";
		}
		return appId;
	};

	componentDidMount() {
		this.props.actions.loadTopics(this.appKey);
	}

	logError = error => {
		this.props.controlPanelActions.displayError(error.response.data.Message);
	};

	createItem = (values, submitHandler) => {
		let appId = this.getAppId();
		let data = Object.assign({}, values, { appId: appId });
		this.props.globalActions.createItem(
			data,
			"/topics",
			() => {
				this.props.actions.loadTopics(this.appKey);
				this.props.history.push("/apps/" + this.appKey + "/topics");
			},
			this.logError,
			submitHandler
		);
	};

	updateItem = (values, submitHandler, itemId) => {
		let appKey = this.appKey;
		this.props.globalActions.updateItem(
			values,
			"/topics/" + itemId,
			() => {
				this.props.actions.loadTopics(appKey);
				this.props.history.push("/apps/" + appKey + "/topics");
			},
			this.logError,
			submitHandler
		);
	};

	copyItem = (values, submitHandler) => {
		let appKey = this.appKey;
		let appId = this.getAppId();
		let data = Object.assign({}, values, { appId: appId });
		this.props.globalActions.createItem(
			data,
			"/topics",
			() => {
				this.props.actions.loadTopics(appKey);
				this.props.history.push("/apps/" + appKey + "/topics");
			},
			this.logError,
			submitHandler
		);
	};

	deleteItem = (id, name) => {
		let appKey = this.appKey;
		this.props.globalActions.deleteItem(
			"/topics/" + id,
			() => {
				this.props.actions.loadTopics(appKey);
			},
			this.logError,
			name
		);
	};

	renderGrid = () => {
		const { topics } = this.props.topics;

		return (
			<div>
				{topics ? (
					<Grid
						defaultText="There are no topics to display. Please create your first topic..."
						objectKey="topics"
						pluralItemName="Topics"
						items={topics}
						data={this.props}
						delete={this.deleteItem}
					/>
				) : (
					<div></div>
				)}
			</div>
		);
	};

	render() {
		const { topics } = this.props;
		return (
			<Page title="Topics">
				{topics ? (
					<GridFormSwitcher
						objectKey="topics"
						singleItemName="Topic"
						pluralItemName="Topics"
						RenderCopy={TopicFormWrapper}
						RenderEdit={TopicFormWrapper}
						RenderNew={TopicFormWrapper}
						items={topics.topics}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

TopicsPage.propTypes = {
	match: PropTypes.any,
	topics: PropTypes.object,
	actions: PropTypes.any,
	globalActions: PropTypes.any,
	history: PropTypes.object,
	apps: PropTypes.array,
	controlPanelActions: PropTypes.object,
};

const mapStateToProps = state => ({
	topics: state.topics,
	apps: state.apps.apps,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(topicsActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TopicsPage);
